import { RoomHeatingControllerConfiguration } from '../modules/modules.interface';
import { HeatingSystem, Home } from './homes.interface';

const emptyHomes: Home[] = [];

export interface HomesState {
  homes: Home[];
  currentHomeId: string | null;
  thermoregulationConfig: {
    heatingSystem: HeatingSystem | null;
    heatingController: RoomHeatingControllerConfiguration | null;
  };
  loading: boolean;
  /**
   * For network error 400
   * Used to show/hide the error modal
   */
  errorModalDisplay: boolean;
}

export const initialHomesState: HomesState = {
  homes: emptyHomes,
  currentHomeId: null,
  thermoregulationConfig: {
    heatingSystem: null,
    heatingController: null,
  },
  loading: false,
  errorModalDisplay: false,
};
